module.exports = __webpack_public_path__ + "static/media/coffee-bean.73d70ed3.bmp";